import React, { useEffect, useMemo, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import SendDocs from "../containers/SendDocs";
import DippingParameters from "../containers/DippingParameters/DippingParameters";
import GlovesTracking from "../containers/GlovesTracking/GlovesTracking";
import Dashboard from "../containers/Dashboard/Dashboard";
import GlovesPairing from "../containers/GlovesPairing/GlovesPairing";
import CubeJsApiWrapper from "../cubejs/CubeJsApiWrapper";
import ReportMain from "../containers/Reports & Approvals/ReportMain";
import Analytics from "../containers/AdvanceAnalytics/Analytics";
import Quality from "../containers/AdvanceAnalytics/Quality";
import CustomerMainReport from "../containers/CustomerReport/CustomerMainReports";
import CertificateofAccorance from "../containers/CustomerReport/Certificate";
import SalesSummary from "../containers/AdvanceAnalytics/SalesMainSummary";
import QualityMain from "../containers/AdvanceAnalytics/QualityMain";
import { VisualPercentageChart } from "../containers/AdvanceAnalytics/VisualPercentageChart";
import { Production } from "../containers/AdvanceAnalytics/Production";
import { SubProduction } from "../containers/AdvanceAnalytics/SubProduction";
import ProductionStatus from "../containers/Dashboard/ProductionStatus";
import AnalyticsStatus from "../containers/Dashboard/AnalyticsStatus";
import CSVReport from "../containers/Dashboard/CSVReport";
import VisualClassWiseChart from "../containers/AdvanceAnalytics/VisualClassWiseChart";
import FinalVisualClassWiseChart from "../containers/AdvanceAnalytics/FinalVisualClassWiseChart";
import { ElectricTestRejectionTable } from "../containers/AdvanceAnalytics/ElectricTestRejectionTable";
import ElectricClassWiseChart from "../containers/AdvanceAnalytics/ElectricTestClasswiseyieldTable";
import { ManualDatabase } from "../containers/manualdatabase/ManualDatabase";
import { PackDispatch } from "../containers/Dashboard/PackDispatch";
import { useNavigate } from "react-router-dom";
import UploadMainReport from "../containers/UploadExcel/UploadFileMain";
import Upload_Excel_History from "../containers/UploadExcel/Upload_Excel_History";
import RandomCSV from "../components/RandomCSC/RandomCSV";
import RawMaterial from "../containers/RawMaterial/RawMaterial";
import RawMaterialReport from "../containers/RawMaterial/RawMaterialReport";
import SFGstore from "../containers/SFGstore/SFGstore";
import SFGHistory from "../containers/SFGstore/SFGHistory";
import ProductionLine from "../containers/ProductionLine/ProductionLine";
import GlovesReport from "../containers/GlovesTracking/GlovesReport";
import ProductionLineStripping from "../containers/ProductionLine/ProductionLineStripping";
import ProductionLineChart from "../containers/ProductionLine/ProductionLineChart";
import SFGPrinter from "../containers/SFGstore/SFGPrinter";
import AbortBatchData from "../containers/DippingParameters/AbortBatchData";
import MqttData from "../containers/MqttData";
import { Dialog } from "@mui/material";
import AutoAddBatch from "../containers/AddBatch/AutoAddBatch";
import { autoAddBatch } from "../containers/DippingParameters/Services";
import { toast } from "react-toastify";
import MqttDataOpen from "../containers/DippingParameters/MQTTOpenPOPup";
import PassFailGrid from "../containers/ProductionLine/OurFeedVisualInspection";
import SelectBatch from "../containers/ProductionLine/SelectBatch";
import Alarm from "../components/Alarm/Alarm";
import ReportVisualInspection from "../containers/Reports & Approvals/OutFeedVisualInspection";
import { useSelector } from "react-redux";
import Acconditioning from "../containers/GlovesTracking/AcCondition";
import DippingCells from "../containers/DippingParameters/DippingCells";
import DippingCogulant from "../containers/DippingParameters/DippingCogulant";
import TunnelOven from "../containers/Tunnel Oven/TunnelOven";
import SFGInventoryTable from "../containers/SFGstore/SFGInventoryTable";
import RetrieveHistory from "../containers/SFGstore/RetrieveHistory";
import SFGBoxStorage from "../containers/SFGstore/SFGBoxStorage";
import ViewSFGHistory from "../containers/SFGstore/ViewSFGHistory";
import DownloadDatabase from "../containers/DownloadDatabase/DownloadDatabase";
import ChangeCICPassword from "../containers/ChangeCICPassword/ChangeCICPassword";


const AuthenticationRoutes = () => {
   const { login } = useSelector((state) => state.batchState);
  const [openM, setOpen] = React.useState(false);
  const [topic, setTopic] = useState([
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:RFID1",
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:RFID6",
  ]);
  const [mqttData, setMqttData] = useState([]);
  const [dialogContent, setDialogContent] = useState("");
  const [autoAddBatchData, setAutoAddBatchData] = useState({});

  const mergedArray = useMemo(
    () => (mqttData ? [].concat(...Object.values(mqttData)) : []),
    [mqttData]
  );
  const rfidTag = useMemo(
    () => mergedArray.filter((item) => item.device_tag === "RFID1"),
    [mergedArray]
  );
  const rfidTag6 = useMemo(
    () => mergedArray.filter((item) => item.device_tag === "RFID6"),
    [mergedArray]
  );

  // const rfidTag = mergedArray.filter((item) => item.device_tag === "RFID1");
  const last4TagValues = rfidTag.slice(-4).map((item) => item.tagValue);
  // const rfidTag6 = mergedArray.filter((item) => item.device_tag === "RFID6");

  const isApiFailure = useRef(false); // Track API failure
  const isScanFailure = useRef(false); // Track API failure

  useEffect(() => {
    if(login.is_production_line_access){
    if (isApiFailure.current) {
      return; // Prevent overriding with setOpen(true)
    }

    if (rfidTag.length >= 4) {
      setOpen(true);
      setDialogContent("AUTO");
    } else {
      setOpen(false);
      isApiFailure.current = true;
    }
  }
  }, [rfidTag]);

  useEffect(() => {
    if(login.is_production_line_access){
    if (rfidTag6.length >= 4) {
      navigate(`/production-line-stripping`);
    }
  }
  }, [rfidTag6]);

  const handleCloseM = () => {
    isApiFailure.current = true;
    setOpen(false);
  };

  const handleClickOpen = (type, data) => {
    setAutoAddBatchData(data);
    if (type === "batchRequest") {
      setDialogContent("AUTO");
    }
    setOpen(true);
  };

  const lastProcessedLength = useRef(0);

  const handleAutoBatch = async () => {
    const rfidTags = mergedArray.filter((item) => item.device_tag === "RFID1");

    if (!rfidTags.length) {
      console.log("No RFID1 tags found.");
      return;
    }

    if (
      rfidTags.length % 4 !== 0 ||
      lastProcessedLength.current === rfidTags.length
    ) {
      console.log(
        `RFID1 tag count (${rfidTags.length}) is not a new multiple of 4, waiting...`
      );
      return;
    }

    lastProcessedLength.current = rfidTags.length; // Update processed length

    console.log("last4TagValues", last4TagValues);

    setTimeout(async () => {
      const params = {
        tag_name: last4TagValues,
      };

      try {
        const resp = await autoAddBatch(params);

        if (resp.status === 200 || resp.status === 201) {
          if (resp.data.success) {
            setAutoAddBatchData(resp.data.payload);
            toast.success(resp.data.message);
            isApiFailure.current = false; // Reset failure flag
          } else {
            console.log("API responded with success: false");
            isApiFailure.current = true; // Mark failure
            setOpen(false);
            toast.error(resp.data.message);
          }
        }
      } catch (error) {
        console.log("API request failed");
        isApiFailure.current = true; // Mark failure
        setOpen(false);
        toast.error(error.response?.data?.message || "Something went wrong.");
      }
    }, 3000);
  };

  useEffect(() => {
    if(login.is_production_line_access){
      if (
        rfidTag.length % 4 === 0 &&
        rfidTag.length !== 0 &&
        lastProcessedLength.current !== rfidTag.length
      ) {
        handleAutoBatch();
      }
    }
    
  }, [rfidTag]);

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = window.location.pathname;

  const endpoints = [
    "/dashboard",
    "/productionStatus",
    "/PackDispatch",
    "/analyticsStatus",
    "/csv-report",
    "/dipping-parameters",
    "/gloves-tracking",
    "/gloves-pairing",
    "/reports",
    "/analytics",
    "/production",
    "/production/production",
    "/quality-analytics",
    "/sales-summary",
    "/analytics/quality",
    "/percentage-chart",
    "/classwise-chart",
    "/manual-database",
    "/rejection-chart",
    "/finalvisual-chart",
    "/customer-report",
    "/certificate",
    "/electric-test-class-wise-yield",
    "/uploadexcel",
    "/upload-excel",
    "/upload-excel-history",
    "/random-uid",
    "/raw-material",
    "/raw-material-report/",
    "/SFG-store",
    "/sfg-history",
    "/production-line",
    "/gloves-report",
    "/production-line-stripping",
    "/production-line-chart",
    "/sfg-printer",
    "/abort-batch",
    "/feed-visual-inspection",
    "/select-batch",
    "/alarm",
    "/dipping-cell",
    "/report-visual-inspection",
    "/ac-conditioning-room",
    "/dipping-coagulant",
    "/tunnel-oven",
    "/sfg-entry",
    "/sfg-inventory",
    "/retrive-history",
    "/sfg-box-storage",
    "/view-history",
    "/download-database",
    "/change-cic-password"
  ];

  useEffect(() => {
    // Check if the current path matches a static endpoint
    const isStaticEndpoint = endpoints.some((endpoint) =>
      location.pathname.startsWith(endpoint)
    );

    // Separate condition for dynamic route `/raw-material-report/:id`
    const isRawMaterialReport = location.pathname.startsWith(
      "/raw-material-report/"
    );

    if (!isStaticEndpoint && !isRawMaterialReport) {
      navigate("/dashboard");
    }
  }, [location.pathname, navigate]);

  return (
    <CubeJsApiWrapper>
      <MqttDataOpen
        topics={topic}
        setMqttTagData={setMqttData}
        // allData={allStationData}
      />
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/productionStatus" element={<ProductionStatus />} />
        <Route path="/PackDispatch" element={<PackDispatch />} />
        <Route path="/analyticsStatus" element={<AnalyticsStatus />} />
        <Route path="/csv-report" element={<CSVReport />} />
        <Route path="/dipping-parameters" element={<DippingParameters />} />
        <Route path="/gloves-tracking" element={<GlovesTracking />} />
        <Route path="/gloves-pairing" element={<GlovesPairing />} />
        <Route path="/reports" element={<ReportMain />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/production" element={<Production />} />
        <Route path="/production/production" element={<SubProduction />} />
        <Route path="/quality-analytics" element={<QualityMain />} />
        <Route path="/sales-summary" element={<SalesSummary />} />
        <Route path="/analytics/quality" element={<Quality />} />
        <Route path="/percentage-chart" element={<VisualPercentageChart />} />
        <Route path="/classwise-chart" element={<VisualClassWiseChart />} />
        <Route path="/manual-database" element={<ManualDatabase />} />
        <Route path="/upload-excel" element={<UploadMainReport />} />
        <Route path="/feed-visual-inspection/:id" element={<PassFailGrid />} />
        <Route path="/ac-conditioning-room" element={<Acconditioning />} />
        <Route path="/tunnel-oven" element={<TunnelOven />} />
        <Route path="/sfg-box-storage" element={<SFGBoxStorage />} />
        <Route
          path="/upload-excel-history"
          element={<Upload_Excel_History />}
        />
        <Route path="/SFG-store" element={<SFGstore />} />
        <Route path="/sfg-history" element={<SFGHistory />} />
        <Route path="/sfg-entry" element={<SFGPrinter />} />
        <Route path="/sfg-inventory" element={<SFGInventoryTable />} />
        <Route path="/retrive-history" element={<RetrieveHistory />} />
        <Route path="/view-history/:id" element={<ViewSFGHistory />} />
         <Route path="/change-cic-password" element={<ChangeCICPassword />} />
        <Route
          path="/abort-batch"
          element={
            <AbortBatchData
              dialogContent={dialogContent}
              openM={openM}
              setOpen={setOpen}
              setDialogContent={setDialogContent}
              handleClickOpen={handleClickOpen}
            />
          }
        />

        <Route
          path="/rejection-chart"
          element={<ElectricTestRejectionTable />}
        />
        <Route
          path="/electric-test-class-wise-yield"
          element={<ElectricClassWiseChart />}
        />
        <Route
          path="/finalvisual-chart"
          element={<FinalVisualClassWiseChart />}
        />
        <Route path="/customer-report" element={<CustomerMainReport />} />
        <Route path="/certificate" element={<CertificateofAccorance />} />

        <Route path="/random-uid" element={<RandomCSV />} />

        <Route path="*" element={<Dashboard />} />

        <Route path="/raw-material" element={<RawMaterial />} />
        <Route
          path="/raw-material-report/:id"
          element={<RawMaterialReport />}
        />
        <Route path="/production-line" element={<ProductionLine />} />
        <Route path="/gloves-report/:id" element={<GlovesReport />} />
        <Route
          path="/production-line-stripping"
          element={<ProductionLineStripping />}
        />
        <Route path="/select-batch" element={<SelectBatch />} />
        <Route
          path="/production-line-chart/:id"
          element={<ProductionLineChart />}
        />
        <Route
          path="/production-line-chart/"
          element={<ProductionLineChart />}
        />
        <Route
          path="/report-visual-inspection/:id"
          element={<ReportVisualInspection />}
        />
        <Route path="/sfg-printer" element={<SFGPrinter />} />

        <Route path="/alarm" element={<Alarm/>} />
        <Route path="/dipping-cell" element={<DippingCells/>} />
        <Route path="/dipping-coagulant" element={<DippingCogulant />} />
        <Route path="/download-database" element={<DownloadDatabase />} />
      </Routes>
      <Dialog open={openM} onClose={handleCloseM}>
        <AutoAddBatch
          onCloseClick={handleCloseM}
          dialogContent={dialogContent}
          autoAddBatchData={autoAddBatchData}
          setOpen={setOpen}
          isApiFailure={isApiFailure}
        />
      </Dialog>
    </CubeJsApiWrapper>
  );
};
export default AuthenticationRoutes;
